/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { menuDeltaProductRequestSchema } from "./menuDeltaProductRequestSchema.ts";

export const updateMenuDeltaRequestSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string().min(1),
	baseHash: z.string().min(1).max(64),
	newHash: z.string().min(1).max(64),
	changed: z.array(menuDeltaProductRequestSchema).optional(),
	removed: z.array(z.uuid()).optional(),
	sizes: z.array(z.uuid()).nullish(),
});
